/* tslint:disable */

/**
 */
export class MachineMsg {
    status?: number;
    message?: string;
}
